import CategoryItem from './model';

export default CategoryItem;



// WEBPACK FOOTER //
// ./data/CoveredInClass/Category/CategoryItem/index.js